var exports = {
  "T": "x61f99309--f86bff--bubble",
  "J": "x61f99309--f86bff--unread-bubble",
};

module.exports = exports;
